import { React, useState, useEffect } from "react";
import request from "../../../Helpers/API";
import {
    Modal,
    TextField,
    Typography,
} from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import SaveIcon from '@mui/icons-material/Save';
import { MenuItem } from "@mui/material";

export const AñadirNuevaPiezaModal = ({ open, onClose, folio }) => {
    const [nuevaPieza, setNuevaPieza] = useState({
        folio: folio,
        familia: "",
        codigo: "",
        descripcion: "",
        unidad_medida: "",
        costo_unitario: 0,
        conteo: 0,
        posicion: ""
    });


    const [codigoEncontrado, setCodigoEncontrado] = useState(false);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleChange = (field, value) => {
        setNuevaPieza(prev => ({
            ...prev,
            [field]: value
        }));
    };

    useEffect(() => {
        if (folio) {
            setNuevaPieza(prev => ({
                ...prev,
                folio: folio
            }));
        }
    }, [folio, open]);

    useEffect(() => {
        if (open) {
            setNuevaPieza({
                folio: folio,
                familia: "",
                codigo: "",
                descripcion: "",
                unidad_medida: "",
                costo_unitario: 0,
                conteo: 0,
                posicion: ""
            });

            setCodigoEncontrado(false); // 🔥 CLAVE
        }
    }, [open, folio]);

    const handleClose = () => {
        setNuevaPieza({
            folio: "",
            familia: "",
            codigo: "",
            descripcion: "",
            unidad_medida: "",
            costo_unitario: 0,
            conteo: 0,
            posicion: ""
        });

        setCodigoEncontrado(false); // 🔥 CLAVE

        onClose();
    };

    const titulo = "AGREGAR NUEVA PIEZA";

    const onGetInfoCodigo = async (codigo) => {

        try {

            if (!codigo?.trim()) {
                setCodigoEncontrado(false);
                return;
            }

            setLoader(prev => ({ ...prev, mostrar: true }));

            const result = await request.get(
                `RealizarConteo/InfoPieza?codigo=${codigo}&folio=${folio}`
            );

            setLoader(prev => ({ ...prev, mostrar: false }));
            if (result) {
                setCodigoEncontrado(true);
                setNuevaPieza(prev => ({
                    ...prev,
                    familia: result.familia || "",
                    descripcion: result.descripcion || "",
                }));
            } else {
                setCodigoEncontrado(false);
                setNuevaPieza(prev => ({
                    ...prev,
                    familia: "",
                    descripcion: "",
                    unidad_medida: "",
                    costo_unitario: 0
                }));
            }
        } catch (error) {
            console.log(error)
            setCodigoEncontrado(false);
            setLoader(prev => ({ ...prev, mostrar: false }));
        }
    };

    const onAgregar = async () => {
        try {

            const {
                familia,
                codigo,
                descripcion,
                unidad_medida,
                costo_unitario,
                posicion,
                conteo
            } = nuevaPieza;

            // 🔥 VALIDACIONES INDIVIDUALES
            if (!familia?.trim()) {
                return Swal.fire("AGREGAR PIEZA", "Capture la familia", "warning");
            }

            if (!codigo?.trim()) {
                return Swal.fire("AGREGAR PIEZA", "Capture el código", "warning");
            }

            if (!descripcion?.trim()) {
                return Swal.fire("AGREGAR PIEZA", "Capture la descripción", "warning");
            }

            if (!unidad_medida?.trim() && !codigoEncontrado) {
                return Swal.fire("AGREGAR PIEZA", "Seleccione la unidad de medida", "warning");
            }

            if ((costo_unitario === "" || costo_unitario === null || costo_unitario === undefined || costo_unitario === 0) && !codigoEncontrado) {
                return Swal.fire("AGREGAR PIEZA", "Capture el costo unitario", "warning");
            }

            if (conteo === "" || conteo === null || conteo === undefined || conteo === 0) {
                return Swal.fire("AGREGAR PIEZA", "Capture la cantidad de piezas encontradas", "warning");
            }

            if (!posicion?.trim()) {
                return Swal.fire("AGREGAR PIEZA", "Capture la posición", "warning");
            }

            setLoader(prev => ({ ...prev, mostrar: true }));

            const post = {
                folio: nuevaPieza.folio,
                familia: familia.trim(),
                codigo: codigo.trim(),
                descripcion: descripcion.trim(),
                unidad_medida: unidad_medida,
                costo_unitario: Number(costo_unitario),
                conteo: Number(conteo),
                posicion: posicion.trim(),
                id_auditor: null
            };

            await request.post("RealizarConteo/AgregarNuevaPieza", post);

            setLoader(prev => ({ ...prev, mostrar: false }));

            await Swal.fire({
                title: "AGREGAR PIEZA",
                text: "Pieza agregada con éxito",
                icon: "success",
            });

            setNuevaPieza({
                folio: "",
                familia: "",
                codigo: "",
                descripcion: "",
                unidad_medida: "",
                costo_unitario: 0,
                conteo: 0,
                posicion: ""
            });

            onClose();

        } catch (error) {

            setLoader(prev => ({ ...prev, mostrar: false }));

            Swal.fire(
                "AGREGAR PIEZA",
                JSON.stringify(error?.response?.data || error),
                "error"
            );
        }
    };

    const textFieldStyles = {
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
            fontSize: "13px",

            "& fieldset": {
                borderColor: "#e0e0e0",
            },

            "&:hover fieldset": {
                borderColor: "#bdbdbd",
            },

            "&.Mui-focused fieldset": {
                borderColor: "#2e7d32",
                borderWidth: "1px",
            },
        },

        "& .MuiInputBase-input": {
            color: "#555",
            // padding: "8px 12px",

            "&::placeholder": {
                color: "#aaa",
                opacity: 1,
            },
        },
    };

    const labelStyle = {
        fontSize: "13px",
        marginBottom: "6px",
        color: "#555",
        fontWeight: 500,
    };

    return (
        <>
            <LoaderScreen loader={loader} />

            <Modal open={open} onClose={onClose}>
                <div className="agregar-pieza-conteo-modal-formulario">

                    <div className="agregar-pieza-conteo-modal-plantilla">

                        <div
                            className="agregar-pieza-conteo-container"
                            id="mdlFiltros-modal"
                        >

                            <PlantillaScreen
                                titulo={titulo}
                                className_main={1}
                                className={"agregar-pieza-conteo-container-modal"}
                            >

                                <div
                                    className="cerrar-modal-button"
                                    onClick={handleClose}
                                >
                                    X
                                </div>

                                <div className={`agregar-pieza-conteo-modal`}>

                                    <div
                                        className="agregar-pieza-conteo-modal-container"
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "1fr 1fr",
                                            gap: "14px",
                                            padding: "10px 5px",
                                        }}
                                    >
                                        <div>
                                            <Typography sx={labelStyle}>Familia</Typography>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                value={nuevaPieza.familia}
                                                onChange={(e) => handleChange("familia", e.target.value)}
                                                sx={textFieldStyles}
                                                disabled={codigoEncontrado}
                                            >
                                                <MenuItem value="RD">RD</MenuItem>
                                                <MenuItem value="RF">RF</MenuItem>
                                                <MenuItem value="RP">RP</MenuItem>
                                                <MenuItem value="RV">RV</MenuItem>
                                                <MenuItem value="RW">RW</MenuItem>
                                            </TextField>
                                        </div>

                                        <div>
                                            <Typography sx={labelStyle}>Código</Typography>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                value={nuevaPieza.codigo}
                                                inputProps={{
                                                    maxLength: 50
                                                }}
                                                onChange={(e) => handleChange("codigo", e.target.value)}
                                                sx={textFieldStyles}
                                                onBlur={(e) => onGetInfoCodigo(e.target.value)}
                                            />
                                        </div>

                                        <div style={{ gridColumn: "span 2" }}>
                                            <Typography sx={labelStyle}>Descripción</Typography>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                value={nuevaPieza.descripcion}
                                                disabled={codigoEncontrado}
                                                inputProps={{
                                                    maxLength: 200
                                                }}
                                                onChange={(e) => handleChange("descripcion", e.target.value)}
                                                sx={textFieldStyles}
                                            />
                                        </div>
                                        {!codigoEncontrado && (
                                            <>
                                                <div>
                                                    <Typography sx={labelStyle}>Unidad de medida</Typography>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        size="small"
                                                        value={nuevaPieza.unidad_medida}
                                                        onChange={(e) => handleChange("unidad_medida", e.target.value)}
                                                        sx={textFieldStyles}
                                                        disabled={codigoEncontrado}
                                                    >
                                                        <MenuItem value="PZ">PZ</MenuItem>
                                                    </TextField>
                                                </div>
                                                <div>
                                                    <Typography sx={labelStyle}>Costo unitario</Typography>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        type="number"
                                                        value={nuevaPieza.costo_unitario}
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            if (/^\d*\.?\d*$/.test(value)) {
                                                                handleChange("costo_unitario", value);
                                                            }
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (["+", "-", "e", "E"].includes(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        sx={textFieldStyles}
                                                    />
                                                </div>
                                            </>

                                        )}

                                        {/* Posición (ocupa 2 columnas) */}
                                        <div>
                                            <Typography sx={labelStyle}>Ubicación</Typography>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                value={nuevaPieza.posicion}
                                                inputProps={{
                                                    maxLength: 30
                                                }}
                                                onChange={(e) => handleChange("posicion", e.target.value)}
                                                sx={textFieldStyles}
                                            />
                                        </div>

                                        <div>
                                            <Typography sx={labelStyle}>Cantidad</Typography>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                type="number"
                                                value={nuevaPieza.conteo}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange("conteo", value);
                                                    }
                                                }}
                                                onKeyDown={(e) => {
                                                    if (["+", "-", "e", "E"].includes(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                sx={textFieldStyles}
                                            />
                                        </div>
                                    </div>

                                    <div className="agregar-pieza-conteo-modal-buttons">

                                        <button className="pa-btn pa-btn--primary"
                                            onClick={() => onAgregar()}
                                        >
                                            <SaveIcon style={{ fontSize: 18 }} />
                                            Guardar
                                        </button>

                                    </div>

                                </div>

                            </PlantillaScreen>

                        </div>

                    </div>

                </div>
            </Modal>
        </>
    );
};